import React from "react";
import List from "./view/List.js";

const Pagamentos = (props) => {
  return <List {...props} />;
};

export default Pagamentos;
